<template>
  <div>
    <img
      class="icon-8x margin-top-10x text-center margin-left-22x"
      :src="uploadpath + 'inst/' + Inst.logo"
      alt=""
    />
    <div class="f-48 text-center">{{Inst.name}}</div>
    <div class="margin-7x f-32 f-g4">
      {{Inst.introduction}}
    </div>
    <div class="justify-between bd-bottom margin-left-3x margin-right-3x padding-bottom-4x padding-top-4x">
      <div>客服热线</div>
      <div>{{Inst.customerservicemobile}}</div>
    </div>
    <div class="justify-between bd-bottom margin-left-3x margin-right-3x padding-bottom-4x padding-top-4x">
      <div>微信客服</div>
      <div>{{Inst.wxcustomer}}</div>
    </div>
    <div class="justify-between bd-bottom margin-left-3x margin-right-3x padding-bottom-4x padding-top-4x">
      <div>微信公众号</div>
      <div>{{Inst.official_account}}</div>
    </div>
    <img
        class="icon-11x under2"
        :src="uploadpath + 'resource/' + Res.back"
        alt=""
        @click="routeto('/')"
      />
  </div>
</template>
<script>
import Config from "../Config";
import { PageHelper } from "../PageHelper";
import { HttpHelper } from "../HttpHelper";
import { Utils } from "../Utils";

export default {
  data() {
    return {
      Res: {},
      Inst: {},
      Member: null,
      bannerlist: [],
      productlist: [],
      problemlist: [],
      attrlist: [],
      list: [],
      show: false,
      right: "A",
    };
  },
  created() {
    PageHelper.Init(this);
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/About.vue